import apiFetch from '../apiFetch'

export default function (token, purchasePresentTypeId) {
  return apiFetch({ endPoint: `PurchasePresentTypes/${purchasePresentTypeId}`, method: 'GET', body: null, token: token })
}
